import React from "react";
import SupportFormScreen from "./SupportFormScreenContainer";
import ScheduleOneSupportForm from "./ScheduleOneSupportFormContainer";
import hoc from "../../../modules/hoc";
import userContext from "../../../modules/userContext";
import ProfileWidget from "./ProfileWidgetContainer";

const {
  hof: { withChildren }
} = hoc;

const {
  components: { HideIfUnauthenticatedContainer: HideIfUnauthenticated }
} = userContext;

const children = (
  <div className="widget-background drop-shadow p-gutter mb-gutter rad-corners">
    <h2 className="support-page-header" style={{ marginBottom: "30px" }}>
      Do you need a paper copy of your most recent Schedule 1?
    </h2>
    <HideIfUnauthenticated>
      <section className="section-spacer">
        <ProfileWidget />
      </section>
    </HideIfUnauthenticated>
    <ScheduleOneSupportForm />
  </div>
);

const ScheduleOneSupportFormScreen = withChildren(children, SupportFormScreen);

export default ScheduleOneSupportFormScreen;
